export default "/assets/images/app-screen4.4f9d3c145e1d3722.webp";